import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ParentId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ParentId {
    return new ParentId(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
